export const API_KEY = 'public_YmhSa0hoQU5yWlA2NnZyVldLNXZqQT09'
export const API_URL = 'https://api.debounce.io/v1/'
